export enum ETypeMaterielAdductionAir {

    Compresseur,
    Cuve,
    SystemeDeFiltration
}